module.exports = __webpack_public_path__ + "img/alfamart.bb0d8159.svg";